<div class="atg-user-management">
  <ng-container *ngIf="mode$ | async as mode">
    <atg-add-user *ngIf="mode === 'add'"></atg-add-user>
    <atg-edit-user *ngIf="mode === 'edit'" [user]="selectedUser$ | async"></atg-edit-user>
  </ng-container>
</div>
